import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const discountService = {
  getDiscounts: async (params) => {
    const response = await authInstance
      .get(
        `${url}/landingDiscountCampaigns/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  getActiveDiscount: async (params) => {
    const response = await authInstance
      .get(
        `${url}/landingDiscountCampaigns/active?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  updateDiscount: async (discountId, data) => {
    const response = await authInstance
      .put(`${url}/landingDiscountCampaigns/${discountId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  createDiscount: async (data) => {
    const response = await authInstance
      .post(`${url}/landingDiscountCampaigns/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  getActiveCodes: async (params) => {
    const response = await authInstance
      .get(`${url}/discountCodes/?` + new URLSearchParams(filterParams(params)))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
